<div class="ad-step1">
    <div class="container">
        <div class="level-bar pt-5 pb-5">
            <div class="half-line level-bar-active"></div>
            <div class="level level-bar-active">1</div>
            <div class="full-line level-bar-active"></div>
            <div class="level level-bar-active">2</div>
            <div class="full-line level-bar-active"></div>
            <div class="level level-bar-active">3</div>
            <div class="full-line level-bar-active"></div>
            <div class="level level-bar-active">4</div>
            <div class="full-line level-bar-active"></div>
            <div class="level level-bar-active">5</div>
            <div class="full-line"></div>
            <div class="level"><img src="assets/check-red.png" style="width: 26px; height: auto" alt=""></div>
            <div class="full-line"></div>
        </div>
        <div class="level-text">
            Step 5 of 5
        </div>
        <div class="page-contents">
            <div class="heading">
                <h1>Choose your ad plans</h1>
                <p>5 steps to post ad of your property.</p>
            </div>
            <div class="form-contents">
                <h3 class="mb-5">Ad Plans for your Property</h3>
                <form action='#' *ngIf="adPlans.length > 0">
                    <div class="row">
                        <div class="col-md-4 mb-4" *ngFor="let adPlan of adPlans">
                            <div class="card" (click)="selectPlan(adPlan.id)" [ngClass]="{'selected': selectedPlan === adPlan.id}">
                                <div class="card-title">
                                    {{ adPlan.plan }}
                                </div>
                                <div class="card-icon">
                                    <img src="assets/basic-01.png">
                                </div>
                                <span class="card-message">Use this plan</span>
                                <div class="card-info">
                                    Rs. {{ adPlan.price }}<br>
                                    <span class="card-time">{{ adPlan.validityDays }} days</span>
                                </div>
                                <div class="underline"></div>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-between pt-5 px-3">
                        <button (click)="previous()">← &nbsp;&nbsp;&nbsp; Previous Step</button>
                        <button [disabled]="fifthAdForm.invalid" (click)="next()">Setup Property &nbsp;&nbsp;&nbsp;→</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
